import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { PricePollingProvider } from './contexts/PricePollingProvider'

// Import test utilities for console access (development only)
if (import.meta.env.DEV) {
  import('./debug/tslMultiPositionTest');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PricePollingProvider>
      <App />
    </PricePollingProvider>
  </StrictMode>,
)
